'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var config = new Map();

config.set('newestOnTop', true);
config.set('timeOut', 5000);

exports.default = config;


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-toastr/lib/config.js
// module id = 294
// module chunks = 0 1